<finxone-web-frontend-text
  [isUsingHtmlStructure]="pageConfig.isUsingHtmlStructure ?? true"
  [contentStyle]="contentStyle"
  [renderedContent]="renderedContent"
></finxone-web-frontend-text>
